/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{padding:50px}.components-library[_ngcontent-%COMP%]   .component-name[_ngcontent-%COMP%]{margin:2em 0 .7em;font-weight:700}"];
export { styles as styles };
